import React, { useEffect, useState } from 'react'

import Flex from '../../../../../../components/layouts/Flex'
import DashboardInput from '../../../../../../components/dashboard/DashboardInput'
import { SingleSelect } from '../../../../../../components/SelectDropdown'
import RadioButtonGroup from '../../../../../../components/RadioButtonGroup'
import RichTextbox from '../../../../../../components/dashboard/controls/RichTextBox'
import { DateTimeInput } from '../../../../../../components/DateTimeInput'
import { Button } from '../../../../../../components/Button'

const JobExperienceForm = ({
  jobExperience,
  onChange,
  onClose,
  showForm,
  onAddJobExperience,
  isEdit,
  applicantIndustryList,
  fieldErrors,
}) => {
  const [applicantIndustry, setApplicantIndustry] = useState(null)
  const [editExperienceTo, setEditExperienceTo] = useState(false)

  useEffect(() => {
    if (jobExperience?.industry) {
      const selectedIndustry = applicantIndustryList.find(
        (level) =>
          level.label === jobExperience?.industry ||
          level.label === jobExperience?.industry.label
      )
      setApplicantIndustry(selectedIndustry)
    }
  }, [jobExperience?.industry])

  useEffect(() => {
    if (jobExperience?.experienceCurrentStatus === 'Currently employed') {
      onChange('experienceTo', new Date())
      setEditExperienceTo(true)
    } else {
      setEditExperienceTo(false)
    }
  }, [jobExperience?.experienceCurrentStatus])

  return (
    <>
      {showForm && (
        <>
          <Flex gap="1rem">
            <DashboardInput
              errorMessage={fieldErrors?.jobTitle}
              name="jobTitle"
              label="Job Title *"
              placeholder="Enter Job Title"
              type="text"
              height="2.5rem"
              value={jobExperience?.jobTitle}
              handleChange={(e) => onChange('jobTitle', e.target.value)}
            />
          </Flex>
          <Flex gap="1rem">
            <DashboardInput
              errorMessage={fieldErrors?.companyName}
              name="companyName"
              label="Company *"
              placeholder="Enter Company"
              type="text"
              height="2.5rem"
              value={jobExperience?.companyName}
              handleChange={(e) => onChange('companyName', e.target.value)}
            />
            <DashboardInput
              errorMessage={fieldErrors?.companyLocation}
              name="companyLocation"
              label="Company Location *"
              placeholder="Enter Company Location"
              type="text"
              height="2.5rem"
              value={jobExperience?.companyLocation}
              handleChange={(e) => onChange('companyLocation', e.target.value)}
            />
          </Flex>
          <Flex gap="1rem">
            <SingleSelect
              title="Industry *"
              options={applicantIndustryList}
              selected={applicantIndustry}
              placeholder="Select Industry"
              onChange={(e) => onChange('industry', e)}
              wrapperClass={fieldErrors?.industry && 'error'}
              subText={fieldErrors?.industry}
            />
          </Flex>
          <Flex direction="column" gap="0.5rem" margin="1rem 0 0 0">
            <RichTextbox
              label="Job Description"
              errorMessage={fieldErrors?.jobDescriptionHtml}
              content={jobExperience?.jobDescriptionHtml}
              setContent={(value) => onChange('jobDescriptionHtml', value)}
            />
          </Flex>
          <Flex>
            <RadioButtonGroup
              title="Work Type"
              name="workType"
              list={[
                {
                  value: 'Permanent Work From Home',
                  label: 'Permanent Work From Home',
                },
                {
                  value: 'Temporary Work From Home',
                  label: 'Temporary Work From Home',
                },
                {
                  value: 'Office',
                  label: 'Office',
                },
              ]}
              selected={jobExperience?.workType || 'Permanent Work From Home'}
              onChange={(value) => onChange('workType', value)}
            />
          </Flex>
          <Flex>
            <RadioButtonGroup
              title="Employment Status"
              name="employmentStatus"
              list={[
                {
                  value: 'No longer employed',
                  label: 'No longer employed',
                },
                {
                  value: 'Currently employed',
                  label: 'Currently employed',
                },
              ]}
              selected={
                jobExperience?.experienceCurrentStatus || 'No longer employed'
              }
              onChange={(value) => onChange('experienceCurrentStatus', value)}
            />
          </Flex>
          <Flex gap="1rem">
            <DateTimeInput
              title="Date From"
              value={
                jobExperience?.experienceFrom
                  ? new Date(jobExperience.experienceFrom)
                  : null
              }
              onChange={(date) => onChange('experienceFrom', date)}
              dateFormat="MMMM dd, yyyy"
              placeholderText="MM/YYYY"
              showYearDropdown
              scrollableYearDropdown
              wrapperClass={fieldErrors?.experienceFrom && 'error'}
              subText={fieldErrors?.experienceFrom}
            />

            <DateTimeInput
              title="Date To"
              value={
                jobExperience?.experienceTo
                  ? new Date(jobExperience.experienceTo)
                  : null
              }
              readOnly={editExperienceTo}
              onChange={(date) => onChange('experienceTo', date)}
              dateFormat="MMMM dd, yyyy"
              placeholderText="MM/YYYY"
              showYearDropdown
              scrollableYearDropdown
              wrapperClass={fieldErrors?.experienceTo && 'error'}
              subText={fieldErrors?.experienceTo}
            />
          </Flex>
        </>
      )}
      <Flex margin="1rem 0 0 0" gap="1rem">
        <Button
          fontSize="0.875rem"
          height="35px"
          bgColor="#41ba80"
          width="50%"
          handleClick={onAddJobExperience}
        >
          {showForm ? (isEdit ? 'Update' : 'Save') : 'Add Job Experience'}
        </Button>
        {showForm && (
          <Button
            fontSize="0.875rem"
            height="35px"
            bgColor="#dc2929"
            width="50%"
            handleClick={onClose}
          >
            Close
          </Button>
        )}
      </Flex>
    </>
  )
}

export default JobExperienceForm
